<template>
  <div class="doctorpc-apply">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="docpc-msg msg-page">
        <div class="msg-hd">
          <div class="msg-png" style="height: auto;">
            <img :src="msg.png" alt="">
          </div>
        </div>
        <div class="msg-bd">
          <div class="title" v-if="msg.title" v-html="msg.title"></div>
          <div class="desc" v-if="msg.desc" v-html="msg.desc"></div>
        </div>
        <div class="msg-ft">
          <van-button v-for="(item, index) in msgButtons" :key="index" :color="item.color" round size="small" @click="item.onClick">
            {{item.txt}}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconsuccess from "@/assets/docpc/icon_success.png"
import iconwarn from "@/assets/docpc/icon_warn.png"
import iconerror from "@/assets/docpc/icon_error.png"
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import {doctorStatus} from '@/utils/doctorStatus'

import {
  mapState,
  mapActions
} from "vuex";
import {
  Toast,
} from "vant";
import {
  doctorGetDetail, syncErecipelDoctor
} from '@/api/doctorapi';
export default {
  name: 'docpcApplyBlank',
  components: {
    docpcSteps
  },
  data() {
    return {
      themeColor: 'linear-gradient(to bottom, #23C7C3, #07A7B4)',
      icon_success: iconsuccess,
      icon_warn: iconwarn,
      icon_error: iconerror,
      stepActive: null,
      doctor_info: null,
      msg: {
        status: '', // success;warn;info;error
        icon: '', // vant-ui Icon name
        png: '',
        title: '',
        desc: ''
      },
      msgButtons: [],
      statusInfo: {
        title: '',
        desc: '',
      }
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    console.log('created', this.docpc.docpcInfo)
    this.getData()
  },
  methods: {
    ...mapActions(['SET_DOCPC_INFO','CLEAR_DOCPC_FORM']),
    async getData() {
      if (!this.docpc.docpcInfo) {
        this.$router.replace({
          name: "docpcLogin",
        });
        return
      }
      await doctorGetDetail({params:{id: this.docpc.docpcInfo.doctor.id}}).then(res => {
        let docpcinfo = this.docpc.docpcInfo
        docpcinfo.doctor = res.data.doctor
        docpcinfo.attaches = res.data.attaches
        this.SET_DOCPC_INFO(docpcinfo)
        this.statusInfo = doctorStatus(res.data.doctor)
        console.log('this.statusInfo', this.statusInfo)
        this.doctor_info = res.data.doctor
        this.$nextTick(()=>{
          if (res.data.doctor.sign_status=='审核通过') {
            this.stepActive = 3
            this.msg.png = this.icon_success
            this.msg.title = '申请通过'
            this.msg.desc = `尊敬的${res.data.doctor.name}医生，您好。您上传的项目专用章回执审核已审核通过，您已正式成为“择美同行-患者援助项目”的慈善医生，感谢您对中国慈善事业的支持。`
            if (this.statusInfo.desc) {
              this.msg.title = this.statusInfo.title
              this.msg.desc = this.statusInfo.desc
            }
            if (res.data.doctor.pap_status == '已录入') {
              this.stepActive = 4
            }
            return
          } else if (res.data.doctor.sign_status=='审核不通过' || res.data.doctor.sign_status=='已上传') {
            this.toSign()
            return
          } 
          if (res.data.doctor.is_pass == "已通过") {
            this.stepActive = 1
            if (res.data.doctor.record_status=='未上传') {
              if (res.data.doctor.record_read != 1) {
                this.msg.png = this.icon_success
                this.msg.title = '恭喜通过考核！'
                this.msg.desc = `<div style="text-align: justify; color:#666;">
                <p style="text-align: left;text-indent:0;">尊敬的${res.data.doctor.name}医生：</p>
                <p>非常感谢您参与由中国初级卫生保健基金会发起的“择美同行--患者援助项目，项目旨在减轻全国转移性非小细胞肺癌（NSCLC)患者的经济负担，帮助所属适应症患者得到持续、规范、有效的治疗，提高患者的生活质量。获知您申请参与“择美同行--患者援助项目"，我们对此感到非常荣幸。作为项目医生，您的患者能否从本项目获益，您将起到关键作用。您的主要工作是接受初保基金会委托对自愿申请的患者进行医学评估和推荐，您的参与将给予患者极大的帮助!感谢您对中国慈善事业的支持!</p>
                <p style="text-align-last: right;">择美同行项目组</p>
                </div>`
                this.msgButtons = [{
                  txt: '开始备案',
                  color: this.themeColor,
                  onClick: this.toMemo.bind(this)
                }]
              } else {
                this.toRecord()
              }
            } else {
              if (res.data.doctor.record_status=='纸质审核通过' && res.data.doctor.seal_status == '已发放') {
                this.stepActive = 2
                this.msg.png = this.icon_success
                this.msg.title = '纸质材料通过'
                this.msg.desc = `尊敬的${res.data.doctor.name}医生，您好。项目办已经寄出您的“项目专用章“，快递单号为：${res.data.doctor.express_sn}，请您注意查收，查收后请您签署《项目专用章签收回执》并上传，感谢您的配合与支持。`
                if (this.statusInfo.desc) {
                  this.msg.title = this.statusInfo.title
                  this.msg.desc = this.statusInfo.desc
                }
                this.msgButtons = [{
                  txt: '前往印章接收',
                  color: this.themeColor,
                  onClick: this.toSign.bind(this)
                }]
              } else {
                this.$router.replace({
                  name: "docpcRecord",
                });
              }
            }
            return
          }
          if (!res.data.doctor.status) {
            if (this.docpc.docpcInfo.hasErecipelDoctor && !res.data.doctor.hospital) {
              this.msgButtons = [{
                txt: '好的，同意采用',
                color: this.themeColor,
                onClick: this.sync.bind(this)
              },
              {
                txt: '不了，重新填写',
                type: this.themeColor,
                onClick: this.toNewComplete.bind(this)
              }]
              this.msg.png = this.icon_success
              this.msg.title = `经查询你已经成为医师公益平台的平台医生，是否在后续申请中采用平台医生已有信息？`
              this.msg.desc = `医师公益平台是一个方便医生统一线上认证，远程签署医生备忘录，医生认证信息上链、方便信息共享的平台，成为平台医生后可便捷申请多个项目。`
            } else {
              this.toComplete()
            }
          } else if (res.data.doctor.status == '等待审核') {
            this.msg.png = this.icon_success
            this.msg.title = `尊敬的${res.data.doctor.name}医生，您好。您上传的医生信息正在审核中，请耐心等待审核结果，感谢您的配合与支持！`
            if (this.statusInfo.desc) {
              this.msg.title = this.statusInfo.title
              this.msg.desc = this.statusInfo.desc
            }
            // this.msgButtons = [{
            //   txt: '确认',
            //   color: this.themeColor,
            //   onClick: this.sync.bind(this)
            // }]
          } else if (res.data.doctor.status == '审核通过') {
            this.stepActive = 0
            this.msg.png = this.icon_success
            this.msg.title = '已通过'
            this.msg.desc = `尊敬的${res.data.doctor.name}医生，您好。您的注册信息已经审核通过，请您尽快参加考试。如有特殊情况请联系项目热线010-56592455。`
            // if (this.statusInfo.desc) {
            //   this.msg.title = this.statusInfo.title
            //   this.msg.desc = this.statusInfo.desc
            // }
            this.msgButtons = [{
              txt: '前往考试培训',
              color: this.themeColor,
              onClick: this.toExam.bind(this)
            }]
          } else if (res.data.doctor.status == '审核不通过') {
            console.log('stepActive',this.stepActive)
            this.msg.png = this.icon_error
            this.msg.title = `尊敬的${res.data.doctor.name}医生，您好。您上传的注册信息未通过，请前往医生信息重新填写！`
            this.msg.desc = `<span style="color:red;">失败原因：${res.data.doctor.apply_reason}</span>`
            if (this.statusInfo.desc) {
              this.msg.title = this.statusInfo.title
              this.msg.desc = this.statusInfo.desc
            }
            this.msgButtons = [{
              txt: '前往信息填写',
              color: this.themeColor,
              onClick: this.toComplete.bind(this)
            }]
          } else if (res.data.doctor.status == '拒绝申请') {
            this.msg.png = this.icon_error
            this.msg.title = `拒绝申请<br>尊敬的${res.data.doctor.name}医生，您好。您上传的医生信息未通过。`
            this.msg.desc = `<span style="color:red;">失败原因：${res.data.doctor.apply_reason}</span>`
            if (this.statusInfo.desc) {
              this.msg.title = this.statusInfo.title
              this.msg.desc = this.statusInfo.desc
            }
          }
        })
        
      }).catch(err => {
        this.$router.replace({
          name: "docpcLogin",
        });
        Toast(err.response.data.message)
      })
    },
    toExam() {
      this.$router.push({
        name: "docpcExam",
      });
    },
    toComplete() {
      this.$router.push({
        name: "docpcApplyComplete",
      });
    },
    toNewComplete() {
      this.CLEAR_DOCPC_FORM()
      this.$router.push({
        name: "docpcApplyComplete",
        query: {
          isNew: 1,
        }
      });
    },
    sync() {
      this.CLEAR_DOCPC_FORM()
      syncErecipelDoctor({
        id: this.docpc.docpcInfo.doctor.id,
        sync:1
      }).then(res => {
        this.toComplete()
      }).catch(err => {
        Toast(err.response.data.message)
      })
    },
    toMemo() {
      if (this.doctor_info.record_read == 1) {
        this.toRecord()
      } else {
        this.$router.push({
          name: "docpcMemo",
        });
      }
      
    },
    toRecord() {
      this.$router.push({
        name: "docpcRecord",
      });
    },
    toSign() {
      this.$router.push({
        name: "docpcSign",
      });
    },
  }
}
</script>

<style lang='less'>
</style>